import { render, staticRenderFns } from "./approval-reason.vue?vue&type=template&id=fca392be"
import script from "./approval-reason.vue?vue&type=script&lang=js"
export * from "./approval-reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports